
import NotesComponent from "../notes/NotesComponent"
import TabHeader from "../../tab/TabHeader"
import SelfPayControls from "./SelfPayControls"
import SelfPayDetails from "./SelfPayDetails"

const SelfPayTab = ({ inWorkQ }) => {

    return <>
        <TabHeader>
            <div className="flex-container">
                <h2>Self Pay</h2>
                <NotesComponent noteTypeId={6} inWorkQ={inWorkQ}/>
            </div>
            <SelfPayControls />
        </TabHeader>
        <div>
            <SelfPayDetails />
        </div>
    </>
}

export default SelfPayTab